import React, { Component } from 'react';
import './Overviews.css'
class TextInputField extends Component {
    render() {

        let inputType = 'text';

        if (this.props.password) {
            inputType = 'password';
        } else if (this.props.email) {
            inputType = 'email';
        }if (this.props.number) {
            inputType = 'number';
        }

        // hasError

        const extraClass = this.props.hasError ? 'is-invalid' : '';
        if(this.props.textarea === undefined){
            return (
                <input
                    style={ this.props.style }
                    className={`${extraClass} ${this.props.className} textcustomsized`}
                    id={`${this.props.field}_field`}
                    disabled={this.props.disabled}
                    contenteditable="true"
                    type={inputType}
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    onChange={(event) => {
                        this.props.onChange(this.props.field, event.target.value,this.props.position,this.props.positionchild);
                    }}
                />
            );
        }
        else{
            return(
                <textarea 
                    className={` ${extraClass} ${this.props.className} textareacustomsized`}
                    style={ this.props.style }
                    disabled={this.props.disabled}
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    rows={this.props.rows}
                    onChange={(event) => {
                        this.props.onChange(this.props.field, event.target.value);
                    }}
                    >
                        
                </textarea>
            )
        }
    }
}

export default (TextInputField);
